import { FC } from 'react';
import { AppHeader } from '@components/AppHeader/AppHeader';
import { IMainLayoutProps } from './types';

export const MainLayout: FC<IMainLayoutProps> = ({ children }) => {
  return (
    <div className={'flex flex-col shrink'}>
      <AppHeader />
      <div className={'w-full'}>
        <div>{children}</div>
      </div>
    </div>
  );
};
